var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreatOrder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4\u5907\u4EFD") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u4F1A\\u6240\\u7BA1\\u7406",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u6253\\u4F4D\\u7BA1\\u7406",
    transform: "translate(-1097.000000, -510.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation/Dropdown/Light/Option",
    transform: "translate(1084.000000, 498.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-12",
    transform: "translate(13.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L14,0 L14,14 L0,14 L0,0 Z",
    id: "history-(Background)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "xinzeng-chuangjian-faqi-06",
    transform: "translate(2.000000, 1.000000)",
    fill: "#262626",
    fillRule: "nonzero",
    stroke: "#262626",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.01229702,11.413174 L1.10055606,11.413174 C0.489136028,11.413174 0,10.924038 0,10.3126179 L0,1.10055606 C0,0.489136028 0.489136028,0 1.10055606,0 L9.11015853,0 C9.72157856,0 10.2107146,0.489136028 10.2107146,1.10055606 L10.2107146,6.13458102 C10.2107146,6.29762636 10.0680499,6.44029104 9.90500457,6.44029104 C9.74195923,6.44029104 9.59929455,6.29762636 9.59929455,6.13458102 L9.59929455,1.10055606 C9.59929455,0.83560739 9.37510721,0.611420035 9.08977787,0.611420035 L1.10055606,0.611420035 C0.815226718,0.611420035 0.591039375,0.83560739 0.591039375,1.10055606 L0.591039375,10.2922373 C0.591039375,10.557186 0.815226718,10.7813733 1.0801754,10.7813733 L5.99191635,10.7813733 C6.15496168,10.7813733 6.29762636,10.924038 6.29762636,11.0870833 C6.29762636,11.2501286 6.17534236,11.413174 6.01229702,11.413174 Z",
    id: "\\u8DEF\\u5F84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.37780177,4.03537223 L2.1603508,4.03537223 C1.99730546,4.03537223 1.85464078,3.89270755 1.85464078,3.72966222 C1.85464078,3.56661688 1.99730546,3.4239522 2.1603508,3.4239522 L7.3574211,3.4239522 C7.52046643,3.4239522 7.66313111,3.56661688 7.66313111,3.72966222 C7.66313111,3.89270755 7.54084711,4.03537223 7.37780177,4.03537223 L7.37780177,4.03537223 Z M5.29897365,7.15361441 L2.1603508,7.15361441 C1.99730546,7.15361441 1.85464078,7.01094973 1.85464078,6.8479044 C1.85464078,6.68485906 1.99730546,6.54219438 2.1603508,6.54219438 L5.29897365,6.54219438 C5.46201899,6.54219438 5.60468366,6.68485906 5.60468366,6.8479044 C5.60468366,7.01094973 5.48239966,7.15361441 5.29897365,7.15361441 Z",
    id: "\\u5F62\\u72B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.90500457,9.08977787 L6.29762636,9.08977787 C6.13458102,9.08977787 5.99191635,8.94711319 5.99191635,8.78406785 C5.99191635,8.62102251 6.13458102,8.47835783 6.29762636,8.47835783 L9.90500457,8.47835783 C10.0680499,8.47835783 10.2107146,8.62102251 10.2107146,8.78406785 C10.2107146,8.94711319 10.0680499,9.08977787 9.90500457,9.08977787 L9.90500457,9.08977787 Z",
    id: "\\u8DEF\\u5F84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.09112514,10.9036573 C7.9280798,10.9036573 7.78541512,10.7609926 7.78541512,10.5979473 L7.78541512,6.99056907 C7.78541512,6.82752374 7.9280798,6.68485906 8.09112514,6.68485906 C8.25417048,6.68485906 8.39683516,6.82752374 8.39683516,6.99056907 L8.39683516,10.5979473 C8.39683516,10.7609926 8.25417048,10.9036573 8.09112514,10.9036573 Z",
    id: "\\u8DEF\\u5F84"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatOrder);
export default __webpack_public_path__ + "static/media/creat-order.af15a1a254955b6be942bbc0f69c8338.svg";
export { ForwardRef as ReactComponent };